import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core'
import { Permissions } from 'src/app/core/enums/permissions.enum'
import { AuthService } from 'src/app/core/services/auth.service'

@Directive({
  selector: '[hasPermissionAny]',
  standalone: false,
})
export class HasPermissionAnyDirective {
  @Input()
  set hasPermissionAny(userPermission: Permissions[]) {
    if (this.authService.hasPermission(userPermission, 'any')) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainer.clear()
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService,
  ) {}
}
